const AccordionItem = ({ label }) => {
  return <div className="accordion__item">{label}</div>
}

export default AccordionItem
